import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function FilterNavigatorV3(props, childrenComponents) {
	return {
		componentName: 'FilterNavigatorV3',
		componentId: uuidv4(),
		props: _.merge({}, props),
		childrenComponents,
	};
}
